import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grid,
  Container,
} from "@mui/material";

// ─── Icons ──────────────────────────────────────────────────────────────────────
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import LinkIcon from "@mui/icons-material/Link";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SmartButtonIcon from "@mui/icons-material/SmartButton";
import TextsmsIcon from "@mui/icons-material/Textsms";
import VideocamIcon from "@mui/icons-material/Videocam";
import PlaceIcon from "@mui/icons-material/Place";
import ShareLocationIcon from "@mui/icons-material/ShareLocation";
import TextMessage from "./TextMessage";
import MediaMessage from "./MediaMessage";
import InteractiveButtonsBuilder from "./InteractiveButtonsBuilder";
import { useLocation, useNavigate } from "react-router-dom";
import SendLocation from "./SendLocation";
import SendLocationRequest from "./SendLocationRequest";
import InteractiveCtaUrls from "./InteractiveCtaUrls";
import InteractiveList from "./InteractiveList";
import AddLinkIcon from "@mui/icons-material/AddLink";
import EndpointMessage from "./EndpointMessage";
import BackBtn from "../../../widgets/BackBtn";
import PageTitle from "../../../widgets/PageTitle";

// ─── Types & helpers ───────────────────────────────────────────────────────────
const TYPES = [
  { id: "text", label: "Text", icon: <TextsmsIcon /> },
  { id: "image", label: "Image", icon: <ImageIcon /> },
  { id: "document", label: "Document", icon: <DescriptionIcon /> },
  { id: "video", label: "Video", icon: <VideocamIcon /> },
  {
    id: "reply_buttons",
    label: "Interactive Reply Buttons",
    icon: <SmartButtonIcon />,
  },
  {
    id: "interactive_cta_urls",
    label: "Interactive CTA URL",
    icon: <LinkIcon />,
  },
  { id: "list", label: "Interactive List", icon: <ListAltIcon /> },
  { id: "location", label: "Location", icon: <PlaceIcon /> },
  {
    id: "location_request_message",
    label: "Location Request",
    icon: <ShareLocationIcon />,
  },
  {
    id: "endpoint",
    label: "Endpoint",
    icon: <AddLinkIcon />,
  },
];
export const typeComponentMap = {
  text: <TextMessage />,
  image: <MediaMessage type="image" />,
  document: <MediaMessage type="document" />,
  video: <MediaMessage type="video" />,
  reply_buttons: <InteractiveButtonsBuilder />,
  location: <SendLocation />,
  list: <InteractiveList />,
  location_request_message: <SendLocationRequest />,
  interactive_cta_urls: <InteractiveCtaUrls />,
  endpoint: <EndpointMessage />,
};
const AddMessages = () => {
  const query = new URLSearchParams(useLocation().search);
  const navigate = useNavigate();
  const pid = query.get("p");
  const [activeType, setActiveType] = useState("text");
  useEffect(() => {
    if (pid && pid !== activeType) {
      setActiveType(pid);
    }
  }, [pid, activeType]);

  return (
    <Container sx={{ mt: 2 }}>
      <BackBtn />
      <PageTitle>Choose message type on the left and create</PageTitle>
      <Box my={2}>
        <Grid container>
          <Grid item sm={4}>
            <Box
              sx={{
                bgcolor: "background.paper",
                borderRight: 1,
                borderColor: "divider",
                overflowY: "auto",
              }}
            >
              <List dense>
                {TYPES.map(({ id, label, icon }) => (
                  <ListItemButton
                    key={id}
                    selected={activeType === id}
                    onClick={() => {
                      navigate(`/home/add-response?p=${id}`, { replace: true });
                    }}
                  >
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText
                      primary={label}
                      primaryTypographyProps={{ fontSize: 14 }}
                    />
                  </ListItemButton>
                ))}
              </List>
            </Box>
          </Grid>
          <Grid item sm={8}>
            {typeComponentMap[activeType] || null}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default AddMessages;
